import { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import LoginContainer from './LoginContainer';

const LoginPageContainer = () => {
  const navigate = useNavigate();
  
  const [searchParams] = useSearchParams();
  const referrer = searchParams.get('r');

  const onSuccess = useCallback(() => {
    if (referrer) {
      navigate(decodeURIComponent(referrer), { replace: true });
    } else {
      navigate('/dashboard/cards', { replace: true });
    }
  }, [navigate, referrer]);

  const onFailure = useCallback(() => {
    navigate('/logout?r=login', { replace: true });
  }, [navigate]);

  return <LoginContainer onFailure={onFailure} onSuccess={onSuccess} />;
};

LoginPageContainer.displayName = 'LoginPageContainer';

export default LoginPageContainer;
